import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_MedicalExamination = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_MedicalExamination' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Medical Examination</h3></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Physician's Name:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of Evaluation</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Physician's Address:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPhysicianName' name='txtPhysicianName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtPhysicianAddress' name='txtPhysicianAddress' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Physician's Phone#</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Person Receiving Examination:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>DOB</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPhysicianPhone' name='txtPhysicianPhone' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtReceiving' name='txtReceiving' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txtDob' name='txtDob' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Age</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Height:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Weight</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPhysicianAge' name='txtPhysicianAge' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtHeight' name='txtHeight' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtWeight' name='txtWeight' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Temperature:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Blood Pressure:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Head Circumference:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtTemperature' name='txtTemperature' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtBloodPressure' name='txtBloodPressure' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtHeadCircumference' name='txtHeadCircumference' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>General Appearance:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtGeneral' name='txtGeneral' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'>Check</span>
                        </td>
                        <td className='w-75'>
                            <span className='eleHeader'>Normal</span>
                        </td>
                        <td className='w-75'>
                            <span className='eleHeader'>Abnormal</span>
                        </td>
                        <td className='w-400'>
                            <span className='eleHeader'>Remarks</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>1. Head</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive_Normal' name='rbActive' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive_Abnormal' name='rbActive' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks' name='txtRemarks' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>2. Fontanelie</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive2_Normal' name='rbActive2' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive2_Abnormal' name='rbActive2' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks2' name='txtRemarks2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>3. Skin</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive3_Normal' name='rbActive3' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive3_Abnormal' name='rbActive3' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks3' name='txtRemarks3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>4. Lymph Nodes</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive4_Normal' name='rbActive4' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive4_Abnormal' name='rbActive4' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks4' name='txtRemarks4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>5. Facies</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive5_Normal' name='rbActive5' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive5_Abnormal' name='rbActive5' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks5' name='txtRemarks5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>6. Eyes a. Right</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive6a_Normal' name='rbActive6a' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive6a_Abnormal' name='rbActive6a' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks6a' name='txtRemarks6a' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>b. Left</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive6b_Normal' name='rbActive6b' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive6b_Abnormal' name='rbActive6b' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks6b' name='txtRemarks6b' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>7. Ears a. Right</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive7a_Normal' name='rbActive7a' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive7a_Abnormal' name='rbActive7a' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks7a' name='txtRemarks7a' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>b. Left</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive7b_Normal' name='rbActive7b' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive7b_Abnormal' name='rbActive7b' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks7b' name='txtRemarks7b' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>8. Nose</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive8_Normal' name='rbActive8' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive8_Abnormal' name='rbActive8' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks8' name='txtRemarks8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>9. Mouth</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive9_Normal' name='rbActive9' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive9_Abnormal' name='rbActive9' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks9' name='txtRemarks9' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>10. Teeth and Gums</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive10_Normal' name='rbActive10' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive10_Abnormal' name='rbActive10' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks10' name='txtRemarks10' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>11. Tongue</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive11_Normal' name='rbActive11' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive11_Abnormal' name='rbActive11' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks11' name='txtRemarks11' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>12. Pharynx & Palate</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive12_Normal' name='rbActive12' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive12_Abnormal' name='rbActive12' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks12' name='txtRemarks12' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>13. Neck</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive13_Normal' name='rbActive13' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive13_Abnormal' name='rbActive13' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks13' name='txtRemarks13' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>14. Thorax</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive14_Normal' name='rbActive14' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive14_Abnormal' name='rbActive14' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks14' name='txtRemarks14' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>15. Heart</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive15_Normal' name='rbActive15' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive15_Abnormal' name='rbActive15' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks15' name='txtRemarks15' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>16. Lungs</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive16_Normal' name='rbActive16' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive16_Abnormal' name='rbActive16' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks16' name='txtRemarks16' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>17. Abdomen</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive17_Normal' name='rbActive17' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive17_Abnormal' name='rbActive17' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks17' name='txtRemarks17' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>18. Breasts</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive18_Normal' name='rbActive18' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive18_Abnormal' name='rbActive18' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks18' name='txtRemarks18' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>19. Genitals</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive19_Normal' name='rbActive19' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive19_Abnormal' name='rbActive19' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks19' name='txtRemarks19' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>20. Spine</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive20_Normal' name='rbActive20' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive20_Abnormal' name='rbActive20' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks20' name='txtRemarks20' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>21. Extremities</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive21_Normal' name='rbActive21' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive21_Abnormal' name='rbActive21' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks21' name='txtRemarks21' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>22. Neurological</b>
                        </td>
                        <td className='w-75'>&nbsp;
                        </td>
                        <td className='w-75'>&nbsp;
                        </td>
                        <td className='w-400'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-180'>
                            <b>a. Cranial</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive22a_Normal' name='rbActive22a' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive22a_Abnormal' name='rbActive22a' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks22a' name='txtRemarks22a' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-180'>
                            <b>b. Reflexes</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive22b_Normal' name='rbActive22b' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive22b_Abnormal' name='rbActive22b' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks22b' name='txtRemarks22b' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-180'>
                            <b>c. Neuromuscular</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive22c_Normal' name='rbActive22c' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive22c_Abnormal' name='rbActive22c' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks22c' name='txtRemarks22c' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-180'>
                            <b>d. Stand and Gait</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive22d_Normal' name='rbActive22d' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive22d_Abnormal' name='rbActive22d' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks22d' name='txtRemarks22d' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-180'>
                            <b>e. Mood/ Behavior</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive22e_Normal' name='rbActive22e' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive22e_Abnormal' name='rbActive22e' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks22e' name='txtRemarks22e' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>23. Urine</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive23_Normal' name='rbActive23' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive23_Abnormal' name='rbActive23' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks23' name='txtRemarks23' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>24. CBC</b>
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive24_Normal' name='rbActive24' className='add-only' value='1' />
                        </td>
                        <td className='w-75'>
                            <input type='radio' id='rbActive24_Abnormal' name='rbActive24' className='add-only' value='0' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtRemarks24' name='txtRemarks24' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-200'>
                            <b>Current Medications:</b>
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtHomeAddress2' name='txtHomeAddress2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <b>Special Dietary Requirements:</b>
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtHomeAddress1' name='txtHomeAddress1' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Based upon the results of this examination and the additional information provided, this person is
                    sufficiently free from disease and does not have any health conditions that would create a hazard
                    for other people.
                </p>


            </div>
        </form >

    )
}











